import { IDoiTuongDaoTaoActionTypes } from "../../action-types/category/IStuDoiTuongDaoTaoActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IStuDoiTuongDaoTaoReducer } from "../../reducer-model/category/IStuDoiTuongDaoTaoReducer";

const initState: IStuDoiTuongDaoTaoReducer = {
  status: eReducerStatusBase.is_not_initialization,
  doiTuongDaoTaos: [],
};
export const doiTuongDaoTaoReducer = (
  state: IStuDoiTuongDaoTaoReducer = initState,
  action: IDoiTuongDaoTaoActionTypes
): IStuDoiTuongDaoTaoReducer => {
  switch (action.type) {
    case "DOI_TUONG_DAO_TAO_LOAD_START":
      return { ...state, status: eReducerStatusBase.is_loading };
    case "DOI_TUONG_DAO_TAO_LOAD_SUCCESS":
      return { ...state, status: eReducerStatusBase.is_completed, doiTuongDaoTaos: action.payload };
    case "DOI_TUONG_DAO_TAO_LOAD_ERRR":
      return { ...state, status: eReducerStatusBase.is_completed };
    default:
      return state;
  }
};
